// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getSiteId } from '@tcp/core/src/utils/utils';
import {
  EmptySearchLinkName,
  SuggestionBox,
  SuggestionLabelTextWrapper,
  BoxHead,
  SuggestionLabel,
} from '../NoResponseSearchDetail.style';
import {
  getSearchBarLabels,
  lblCategoryMatches,
} from '../../../../common/molecules/SearchBar/labels/searchBar.labels';
import { renderLabel } from '../../../../../utils/labels/labelUtilty';

const labels = getSearchBarLabels();

/**
 * This component produces a Search Bar component for Header
 * Expects textItems array consisting of objects in below format
 * {
 *    style: "",
 *    text: ""
 * }
 * This component uses BodyCopy atom and accepts all properties of BodyCopy
 * @param {*} props
 */
class CategoryMatches extends React.PureComponent {
  render() {
    const { searchResults, redirectToSuggestedUrl } = this.props;

    return (
      <React.Fragment>
        <SuggestionBox className="suggestionBox">
          {searchResults &&
            searchResults.autosuggestList &&
            searchResults.autosuggestList.length > 0 &&
            searchResults.autosuggestList.map((item) => {
              const isCategory =
                item.heading === renderLabel(labels[lblCategoryMatches], 'lbl_category_matches');
              return (
                <div>
                  {item && item.suggestions.length > 0 && (
                    <BoxHead fontFamily="secondary" className="boxHead matchLinkBoxHead">
                      {item.heading}
                    </BoxHead>
                  )}
                  <BodyCopy component="div" className="matchLinkBoxBody" lineHeight="39">
                    <ul>
                      {item &&
                        item.suggestions &&
                        item.suggestions.map((itemData) => {
                          const itemUrl = isCategory ? itemData.url.replace(/'/g, '') : undefined;
                          return (
                            <EmptySearchLinkName
                              component="li"
                              fontFamily="secondary"
                              fontSize="fs14"
                              key={item.id}
                              className="empty-search-linkName"
                              onClick={(e) => {
                                e.preventDefault();
                                redirectToSuggestedUrl(`${itemData.text}`, itemUrl);
                              }}
                            >
                              <SuggestionLabel
                                className="suggestion-label"
                                to={
                                  isCategory
                                    ? `/${getSiteId()}${itemUrl}`
                                    : `/${getSiteId()}/search/${itemData.text}`
                                }
                                noLink
                              >
                                <SuggestionLabelTextWrapper className="suggestion-label-textWrapper">
                                  {itemData.text}
                                </SuggestionLabelTextWrapper>
                              </SuggestionLabel>
                            </EmptySearchLinkName>
                          );
                        })}
                    </ul>
                  </BodyCopy>
                </div>
              );
            })}
        </SuggestionBox>
      </React.Fragment>
    );
  }
}

CategoryMatches.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.shape({})),
  redirectToSuggestedUrl: PropTypes.func.isRequired,
};

CategoryMatches.defaultProps = {
  searchResults: [],
};

export default CategoryMatches;
